export const DROPDOWNS_REQUEST = 'DROPDOWNS_REQUEST';
export const DROPDOWNS_SUCCESS = 'DROPDOWNS_SUCCESS';
export const DROPDOWNS_FAILURE = 'DROPDOWNS_FAILURE';

export const dropdownsRequest = () => ({
  type: DROPDOWNS_REQUEST,
});

export const dropdownsSuccess = payload => ({
  type: DROPDOWNS_SUCCESS,
  payload,
});

export const dropdownsFailure = payload => ({
  type: DROPDOWNS_FAILURE,
  payload,
});

const initialState = {
  isFetched: false,
  fetching: false,
  error: null,
  dropdowns: null,
};

export function dropdownsReducer(state = initialState, action) {
  switch (action.type) {
    case DROPDOWNS_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case DROPDOWNS_SUCCESS:
      return {
        ...state,
        isFetched: true,
        fetching: false,
        dropdowns: action.payload,
      };
    case DROPDOWNS_FAILURE:
      
      return {
        ...state,
        fetching: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
